<main [class.menu-collapsed]="isMenuCollapsed"  baThemeRun id="mainTheme">
  <div class="additional-bg"></div>
  <router-outlet></router-outlet>
</main>
